/* eslint-disable unused-imports/no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { logBusiness } from 'store/actions/log-actions';
import { showMenu, showFooter } from 'store/actions/util-actions';

import ErrorDisplay from 'components/features/error-display/error-display';
import Header from 'components/templates/header/header';
import Footer from 'components/templates/footer/footer';

import history from 'navigation/history';

const mapStateToProps = (state) => ({
  device: state.customer.device,
  loan: state.personalLending.loan,
});

const mapDispatchToProps = (dispatch) => ({
  logBusiness: (code, duration, input, output, error, device, productItemId) =>
  dispatch(logBusiness(code, duration, input, output, error, device, productItemId)),
  showMenu: (show) => dispatch(showMenu(show)),
  showFooter: (show) => dispatch(showFooter(show)),
});

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: { message: '', path: '' },
    };
  }

  componentDidMount() {
    const { error } = this.state;

    this.unlisten = history.listen((location) => {
      if (location?.pathname !== error?.path) {
        this.setState({ hasError: false });
      }
    });
  }

  componentDidCatch(error) {
    const { loan, device, logBusiness } = this.props;
    const e = { message: error.message, path: window.location.pathname };

    this.setState({ hasError: true, error: e });
    const errorToLog = `${error.message} - path: ${window.location.pathname}`;
    const input = [];
    input.push(loan);
    logBusiness('application-customer-portal-web-page-error', null, input, null, errorToLog, device, loan?.id);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      return (
        <>
          <Header />
          <ErrorDisplay
            hasError={hasError}
            textError="Erro ao renderizar a página."
            description={`Erro: ${error.message}`}
            textButton="Tentar novamente"
            retryFunction={() => window.location.reload()}
            retryTimeout={10}
          />
          <Footer />
        </>
      );
    }

    return this.props.children;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
